/**
 * Advances the journey timeline as the page scrolls: the step nearest the
 * reading line becomes the active one, and the connector fills to its marker.
 *
 * Progressive enhancement. Without JS the step marked "Highlight this step"
 * in the editor stays lit, which is why the stylesheet keeps that rule alive
 * only while the list is missing the js-journey class this adds.
 */
(() => {
  const lists = [...document.querySelectorAll('.ms-journey__list')];
  if (!lists.length) return;

  const still = window.matchMedia('(prefers-reduced-motion: reduce)');

  lists.forEach((list) => {
    const steps = [...list.querySelectorAll('.ms-journey-step')];
    if (steps.length < 2) return;

    const progress = document.createElement('span');
    progress.className = 'ms-journey__progress';
    progress.setAttribute('aria-hidden', 'true');
    list.prepend(progress);
    list.classList.add('js-journey');

    let active = -1;
    let queued = false;

    const measure = () => {
      queued = false;
      // The reading line sits above centre: a step counts as reached once its
      // card has climbed past it, which is what makes the fill track the
      // marker rather than lag a whole step behind.
      const line = window.innerHeight * 0.45;
      let next = 0;
      steps.forEach((step, i) => {
        if (step.getBoundingClientRect().top <= line) next = i;
      });

      if (next === active) return;
      active = next;

      steps.forEach((step, i) => {
        step.classList.toggle('is-active', i === active);
        step.classList.toggle('is-passed', i < active);
      });

      const listTop = list.getBoundingClientRect().top;
      const node = steps[active].querySelector('.ms-journey-step__node');
      const nodeMid = node.getBoundingClientRect().top - listTop + node.offsetHeight / 2;
      progress.style.height = `${Math.max(0, nodeMid)}px`;
    };

    const schedule = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(measure);
    };

    measure();
    if (still.matches) return;

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
  });
})();
